import { useMe } from "@/api/services/main/auth";
import { TUserRole, USER_ROLE } from "@/types/enum";

/**
 * Single source of truth for the logged-in customer user's role (admin/member/viewer),
 * read from /get-me. Drives all role-based UI gating (menu, route guard, action buttons).
 *
 * `role` is optional on the DTO and /get-me is async, so `isLoading` is exposed for callers
 * that must wait before deciding (e.g. the route guard, to avoid flashing a 404 before the
 * role has resolved).
 */
export const useCurrentUserRole = () => {
  const { data, isLoading } = useMe();
  const role = data?.data?.role as TUserRole | undefined;

  const isAdmin = role === USER_ROLE.ADMIN;
  const isMember = role === USER_ROLE.MEMBER;

  return {
    role,
    isLoading,
    isAdmin,
    isMember,
    /** admin + member may view the user-management list/detail; viewer may not. */
    canViewUsers: isAdmin || isMember,
    /** Only admin may create/edit/disable/resend/reset users. */
    canMutateUsers: isAdmin,
  };
};
